import { render, staticRenderFns } from "./DealerWaitTable.vue?vue&type=template&id=5206370e&scoped=true"
import script from "./DealerWaitTable.vue?vue&type=script&lang=js"
export * from "./DealerWaitTable.vue?vue&type=script&lang=js"
import style0 from "./DealerWaitTable.vue?vue&type=style&index=0&id=5206370e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206370e",
  null
  
)

export default component.exports